export const CATEGORIES_ACTION_TYPES = {
  SET_CATEGORIES: 'category/SET_CATEGORIES',
};